import { useJnjBranding } from "@jmc/utils/hooks/useJnjBranding";
import classnames from "classnames";
import React from "react";

import style from "./style.module.scss";

interface Props {
    children: JSX.Element | JSX.Element[];
    backgroundColor?: "white" | "default"; // TODO: Rebranding: Can be removed after rebranding
    fullSizeMobile?: boolean;
    noTopPadding?: boolean;
}

/**
 * This component renders a container block that will fix the content size.
 * It can be used from template pages for services, to get the same page structure
 * as content pages.
 */
export const PageContainer = (props: Props): JSX.Element => {
    const { jnjFullBranded } = useJnjBranding();

    const {
        children,
        backgroundColor = jnjFullBranded ? "white" : "default",
        fullSizeMobile = false,
        noTopPadding = false,
    } = props;

    return (
        <div
            className={classnames(
                style.backgroundWrapper,
                style[backgroundColor],
                fullSizeMobile ? style.full : null,
                noTopPadding ? style.noTopPadding : null,
            )}
            id="bodycontent"
        >
            <div className={style.pageContainer}>{children}</div>
        </div>
    );
};

export default PageContainer;
